import type { Components } from '@mui/material';
import type { Theme } from '@mui/material/styles';

export const MuiBadge: Components<Omit<Theme, 'components'>>['MuiBadge'] = {
  styleOverrides: {
    colorSecondary: {
      backgroundColor: '#152232',
    },
  },
};
